import { STORAGE_KEYS } from '../../constants';
import { IUser } from '../../types';

export interface AuthState {
  token: string | null;
  user: IUser | null;
  workspace: any | null;
  isAuthenticated: boolean;
}

export class AuthInitializationService {
  private static instance: AuthInitializationService;
  private authState: AuthState | null = null;

  private constructor() {}

  public static getInstance(): AuthInitializationService {
    if (!AuthInitializationService.instance) {
      AuthInitializationService.instance = new AuthInitializationService();
    }
    return AuthInitializationService.instance;
  }

  public initializeAuthState(): AuthState {
    if (this.authState) {
      return this.authState;
    }

    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const userData = localStorage.getItem(STORAGE_KEYS.USER);
    const workspaceData = localStorage.getItem(STORAGE_KEYS.WORKSPACE);

    this.authState = {
      token,
      user: userData ? JSON.parse(userData) : null,
      workspace: workspaceData ? JSON.parse(workspaceData) : null,
      isAuthenticated: !!token && this.isTokenValid(token),
    };

    return this.authState;
  }

  private isTokenValid(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp > currentTime;
    } catch (error) {
      return false;
    }
  }

  public getAuthState(): AuthState | null {
    return this.authState;
  }

  public updateAuthState(newState: Partial<AuthState>): void {
    if (this.authState) {
      this.authState = { ...this.authState, ...newState };
    }
  }

  public clearAuthState(): void {
    this.authState = null;
  }

  public shouldFetchData(): boolean {
    if (!this.authState) {
      return false;
    }

    const { token, user, workspace, isAuthenticated } = this.authState;

    if (!isAuthenticated || !token) {
      return false;
    }

    if (user && workspace) {
      return false;
    }

    return true;
  }

  public getRequiredDataToFetch(): {
    needsUser: boolean;
    needsWorkspace: boolean;
  } {
    if (!this.authState) {
      return { needsUser: false, needsWorkspace: false };
    }

    const { user, workspace } = this.authState;

    return {
      needsUser: !user,
      needsWorkspace: !workspace,
    };
  }
}

export const authInitializationService =
  AuthInitializationService.getInstance();
